import axios from 'axios'
//使用工具qs来处理参数
import qs from 'qs'
//加密
import CryptoJS from "crypto-js";
import baseinfo from "./baseinfo";

import { postData } from "./android";

//开发环境url
const DEV_BASE_URL = "/test";
//线上url
const PROD_BASE_URL = "/test";
//判断是开发环境还是 测试环境
const baseURL =
  process.env.NODE_ENV === "production" ? PROD_BASE_URL : DEV_BASE_URL;

const baseKey = "74e4b90c5f211eas1";
const baseIv = "000000000000000";

axios.defaults.baseURL = baseURL
axios.defaults.timeout = 5000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  //在发送请求之前做某件事
  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
  }
  return config;
}, (error) => {
  console.log('错误的传参')
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  //对响应数据做些事
  if (!res.data.success) {
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  console.log('网络异常')
  return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, )
      .then(response => {
        resolve(response);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
//返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: param
      })
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default {
  fetchPost,
  fetchGet,
}


// WEBPACK FOOTER //
// ./src/request/axios.js